<template>
  <div class="row q-pa-md">
    <div class="col-xs-12 col-md-6 q-pa-sm"><FreshCustomers /></div>
    <div class="col-xs-12 col-md-6 q-pa-sm"><LeavingCustomers /></div>
  </div>
  <div class="row q-pa-md">
    <div class="col-xs-12 col-md-12 q-pa-sm"><TodaysAppointments /></div>
  </div>
</template>
<script>
import FreshCustomers from '../components/home/FreshCustomers.vue'
import LeavingCustomers from '../components/home/LeavingCustomers.vue'
import TodaysAppointments from '../components/home/TodaysAppointments.vue'
export default {
  components: {
    FreshCustomers,
    LeavingCustomers,
    TodaysAppointments,
  },
  setup() {},
}
</script>
